import { render, staticRenderFns } from "./user_center.vue?vue&type=template&id=1dc49e7e&scoped=true&"
import script from "./user_center.vue?vue&type=script&lang=js&"
export * from "./user_center.vue?vue&type=script&lang=js&"
import style0 from "./user_center.vue?vue&type=style&index=0&id=1dc49e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc49e7e",
  null
  
)

export default component.exports